export default __webpack_public_path__ + "static/media/electric.c6f723ec.svg";